<template>
	<Component
		:is="as"
		class="
			group
			inline-flex
			items-center
			gap-2
			p-2
			border-b-2
			border-transparent
			hover:border-border-primary
			hover:bg-background-secondary
			active:border-icon-active
			aria-selected:border-icon-active
			md:py-3
			focus-outline
			my-1
		"
		:aria-selected="active"
	>
		<span class="inline-flex w-3">
			<NuxtIcon v-if="active" name="check" class="text-icon-primary group-active:text-icon-active" filled />
			<NuxtIcon v-else name="bullet" class="text-icon-tertiary group-hover:text-icon-neutral group-active:text-icon-active" filled />
		</span>
		<span class="text-body-primary group-active:text-body-primary group-aria-selected:font-bold">
			<slot />
		</span>
	</Component>
</template>

<script setup lang="ts">
	type Props = {
		as?: any;
		active?: boolean;
	};

	withDefaults(defineProps<Props>(), {
		as: 'button',
		active: false,
	});
</script>
